import { createSelector } from 'reselect';
import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectPlannerData = state => selectState(state).data;
export const selectElements = createSelector(selectPlannerData, data =>
  data.elements.filter(element => !element.deleted),
);
export const selectPrograms = state => selectState(state).data.programs;
export const selectChannels = state => selectState(state).data.channels;
export const isPlannerLoading = state => selectState(state).loading;
export const selectPlanFilters = state => selectState(state).filters;

export const selectFilteredPlans = createSelector(
  [selectPrograms, selectPlanFilters],
  (data, { searchText, status, start, end }) => {
    return data.filter(entry => {
      // work ticket number filter - check if search text matches work ticket number prefix
      const matchesWorkTicket =  
        searchText && searchText.trim() !== ''
          ? (() => {
              const workTicketFields = [
                entry.workTicketNo,
                entry.workTicketNumber,
                entry.workTicket,
                entry.workorderid,
                entry.workOrderId,
                entry.processIdExt,
                entry.wtname,
                entry.title,
              ];

              return workTicketFields.some(
                field => field && String(field).toLowerCase().startsWith(searchText.toLowerCase()),
              );
            })()
          : true;

      // status filter
      const matchesStatus = status && status !== 'All' ? entry.status === status : true;

      // date filter - check for overlap between program dates and filter dates
      const matchesDate = (() => {
        if (!start || !end) return true;

        const programStart = new Date(entry.since);
        const programEnd = new Date(entry.till);
        const filterStart = new Date(start + 'T00:00:00');
        const filterEnd = new Date(end + 'T23:59:59');

        // Check for overlap: program starts before filter ends AND program ends after filter starts
        return programStart <= filterEnd && programEnd >= filterStart;
      })();

      const result = matchesWorkTicket && matchesStatus && matchesDate;
      return result;
    });
  },
);

// Memoized selector to avoid creating new object references
export const selectCompletionStatus = createSelector(
  [selectState],
  (plannerState) => plannerState?.completionStatus || {}
);

export const selectCompletionStatusLoading = state => selectState(state).completionStatusLoading;
